import RichTextEditor from "../../RichTextEditor"

export default function DxmlInsertedText({ editorText, writeEnabled }) {
    return (
        <div className="tw-my-3">
            <RichTextEditor editorText={editorText} disabled={!writeEnabled}></RichTextEditor>
        </div>
    )
}